import { buildResponsiveCSS } from '../../../utils/css.mjs';
import styled from 'styled-components';

const GridContainer = styled.div `
  display: grid;

  ${props => buildResponsiveCSS('grid-template-areas', props.gridTemplateAreas)};
  ${props => buildResponsiveCSS('grid-template-rows', props.gridTemplateRows)};
  ${props => buildResponsiveCSS('grid-template-columns', props.gridTemplateColumns)};
  ${props => buildResponsiveCSS('gap', props.gap)};
  ${props => buildResponsiveCSS('padding', props.padding)};
  ${props => buildResponsiveCSS('margin', props.margin)};
`;
const GridArea = styled.div `
  ${props => buildResponsiveCSS('grid-area', props.gridArea)};
  ${props => buildResponsiveCSS('padding', props.padding)};
  ${props => buildResponsiveCSS('margin', props.margin)};
  ${props => buildResponsiveCSS('display', props.display)};
`;

export { GridArea, GridContainer };
//# sourceMappingURL=GridContainer.mjs.map
